"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var DefaultFormatter_1 = require("./DefaultFormatter");
var BodyCell_1 = require("./BodyCell");
var HeaderColumn_1 = require("./HeaderColumn");
var RowHeaderCell = /** @class */ (function (_super) {
    tslib_1.__extends(RowHeaderCell, _super);
    function RowHeaderCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderHeaderRowHeaderCell = function () {
            var outerAttrs = HeaderColumn_1.HeaderColumn.getDivWrapperProps(_this.props.isSelected, true);
            outerAttrs.style.width = RowHeaderCell.Width;
            outerAttrs.style.verticalAlign = 'top';
            var pointerEventWrapperProps = {
                pointerClick: _this.props.onRowHeaderCellClick
            };
            var innerAttrs = {
                'data-tb-test-id': "" + _this.props.testId + RowHeaderCell.CellTestIdSuffix,
                className: 'tb-react-dg-hcell',
                role: 'button',
                style: { height: '100%' }
                // TODO localized title
            };
            return (React.createElement("div", tslib_1.__assign({}, outerAttrs),
                React.createElement(widgets_1.PointerEventWrapper, tslib_1.__assign({}, pointerEventWrapperProps),
                    React.createElement("div", tslib_1.__assign({}, innerAttrs)))));
        };
        _this.renderBodyRowHeaderCell = function () {
            var pointerEventWrapperProps = {
                pointerClick: _this.props.onRowHeaderCellClick
            };
            var style = BodyCell_1.BodyCell.getStyle(_this.props.isSelected, _this.props.height, RowHeaderCell.Width, true);
            var content = React.createElement(DefaultFormatter_1.DefaultFormatter, { value: '', testId: "" + _this.props.testId + RowHeaderCell.CellTestIdSuffix + "-Cell" });
            var attrs = {
                'data-tb-test-id': "" + _this.props.testId + RowHeaderCell.CellTestIdSuffix,
                style: style,
                role: 'button',
            };
            return (React.createElement(widgets_1.PointerEventWrapper, tslib_1.__assign({}, pointerEventWrapperProps),
                React.createElement("div", tslib_1.__assign({}, attrs), content)));
        };
        return _this;
    }
    RowHeaderCell.prototype.render = function () {
        return (this.props.rowType === RowHeaderCell.RowType.Header) ? this.renderHeaderRowHeaderCell() : this.renderBodyRowHeaderCell();
    };
    RowHeaderCell.displayName = 'DataGridRowHeaderCell';
    RowHeaderCell.element = React.createFactory(RowHeaderCell);
    return RowHeaderCell;
}(React.PureComponent));
exports.RowHeaderCell = RowHeaderCell;
(function (RowHeaderCell) {
    RowHeaderCell.CellTestIdSuffix = '-rowHeaderCell';
    RowHeaderCell.Width = 10;
    var RowType;
    (function (RowType) {
        RowType[RowType["Header"] = 0] = "Header";
        RowType[RowType["Body"] = 1] = "Body";
    })(RowType = RowHeaderCell.RowType || (RowHeaderCell.RowType = {}));
})(RowHeaderCell = exports.RowHeaderCell || (exports.RowHeaderCell = {}));
exports.RowHeaderCell = RowHeaderCell;
//# sourceMappingURL=RowHeaderCell.js.map